import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';

import {
  LinkSurveyTagsResponseDto,
  SurveyTagsDto,
} from './dtos/survey-tags.dto';

@Injectable({ providedIn: 'root' })
export class SurveyTagsApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.url;

  public getSurveyTags(surveyId: number): Observable<number[]> {
    return this._http
      .get<SurveyTagsDto>(`${this._baseUrl}/survey-tags/${surveyId}`, {
        context: withLoading('page'),
      })
      .pipe(map((dto) => dto.tags.map((tag) => tag.id)));
  }

  public linkSurveyTags(
    surveyId: number,
    tagIds: number[],
  ): Observable<number[]> {
    return this._http
      .put<LinkSurveyTagsResponseDto>(
        `${this._baseUrl}/survey-tags/${surveyId}`,
        { tagIds },
      )
      .pipe(map((response) => response.tagIds));
  }
}
